import {CartFetch,} from '../config/route-fetch';
import Util, {NumberUtil, CheckUtil} from './Utils';
import MathUtil from "./math-utils";
import StorageUtil from "./storage-util";
import {SystemConst} from "./constant";
import UrlUtil from "./url-config";

const BusinessUtil = {

    //修改购物车
    updateCart: (cartInfo, _success) => {
        let _arr = [];

        let info = {
            company_id_: localStorage.getItem("companyId"),//公司id
            product_id_: cartInfo.product_id_, //规格id
            goods_id_: cartInfo.goods_id_, //商品id
            number_: cartInfo.number_,//数量
            unit_id_: cartInfo.unit_id_
        };
        _arr.push(info);
        // BusinessUtil.updateSpecInfoWithCartInfo(info);
        CartFetch.saveCart({jsonStr: JSON.stringify(_arr)}, (rs) => {
            if (rs.status === 1) {
                let cartNumber = 0;
                let cartCount = 0;
                let cartTotal = 0;
                let productIds = '';
                let productList = [];
                if (rs.data.pdList.length > 0) {
                    // 获取id串
                    rs.data.pdList.map(goods => {
                        goods.productList.map(product => {
                            product.inputNumber = product.cart_number_;
                            productIds += productIds.length > 0 ? (',' + product.id_) : product.id_;
                            // 返回规格用于更新数量
                            if (product.id_ === cartInfo.product_id_) {
                                productList.push(product)
                            }
                        })
                    });
                    // 获取优惠
                    CartFetch.getPromotionByProductIds({productIds: productIds}, rs1 => {
                        if (rs1.status === 1) {
                            rs1.data.map(promotion => {
                                rs.data.pdList.map(goods => {
                                    if (goods.id_ == promotion.goods_id_) {
                                        goods.productList.map(product => {
                                            if (product.id_ == promotion.product_id_) {
                                                product.promotion = promotion;
                                            }
                                        })
                                    }
                                })
                            });
                            //应用促销规则
                            rs.data.pdList.map(goods => {
                                cartNumber++;
                                let multi_unit_ = Util.toParse(goods.multi_unit_);

                                goods.productList.map(product => {
                                    product = BusinessUtil.usePromotionPrice(product);
                                    cartCount = cartCount + product.cart_number_;

                                    // 多单位并且选择的不是默认单位,计算价格
                                    if (goods.is_multi_unit_ && product.unit_id_ !== multi_unit_.unit_id_) {
                                        let units = {};
                                        multi_unit_.extend_units_.map(unit => {
                                            if (product.unit_id_ === unit.unit_id_) {
                                                units = unit;
                                            }
                                        });
                                        // 单位换算
                                        cartTotal = cartTotal + (product.cart_number_ * product.realPrice * units.scale_);
                                        if (!product.promotion && product.is_original_price_ && multi_unit_.enable_discount_) {
                                            cartTotal -= (units.discount_ * product.cart_number_)
                                        }
                                    } else {
                                        cartTotal = cartTotal + (product.cart_number_ * product.realPrice);
                                    }
                                })
                            });
                            window.cartNumber = cartNumber;
                            window.cartCount = cartCount;
                            window.cartTotal = cartTotal;
                            window.cartInfo = rs.data.pdList;
                            localStorage.setItem('cartNumber', window.cartNumber);
                            localStorage.setItem('cartCount', window.cartCount);
                            localStorage.setItem('cartTotal', window.cartTotal);
                            window.cartInfo = rs.data.pdList;
                            _success(window.cartTotal, window.cartCount, window.cartTotal, productList);
                        }
                    })

                }


                if (rs.data.pdList.length === 0) {
                    window.cartNumber = cartNumber;
                    window.cartCount = cartCount;
                    window.cartTotal = cartTotal;
                    localStorage.setItem('cartNumber', window.cartNumber);
                    localStorage.setItem('cartCount', window.cartCount);
                    localStorage.setItem('cartTotal', window.cartTotal);
                    window.cartInfo = rs.data.pdList;
                    _success(window.cartNumber, window.cartCount, window.cartTotal, productList);
                }
            }
        })
    },
    updateWindowCart: pdList => {
        let cartNumber = 0, cartCount = 0, cartTotal = 0;
        if (pdList && pdList.length > 0) {

            pdList.map(goods => {
                cartNumber++;
                goods.productList.map(product => {
                    cartCount = cartCount + product.cart_number_;
                    cartTotal = cartTotal + (product.cart_number_ * product.price_);

                    //同时修改商品规格的存储信息
                    let info = {
                        company_id_: localStorage.getItem("companyId"),//公司id
                        product_id_: product.id_, //规格id
                        goods_id_: goods.id_, //商品id
                        number_: product.cart_number_//数量
                    };
                });

            })
        }
        window.cartNumber = cartNumber;
        window.cartCount = cartCount;
        window.cartTotal = cartTotal;
        window.cartInfo = pdList;

        localStorage.setItem("cartCount", cartCount);
        let company_id_ = localStorage.getItem("companyId");//公司id
        //同时修改商品规格的存储信息
        if ((!pdList || pdList.length == 0) && company_id_) {
            let key = "GoodsSpec_" + company_id_;
            localStorage.removeItem(key);
        }

    },

    //判断订单是否有优惠信息,有则应用优惠信息
    userOrderPromotionPrice: (cartData) => {
        if (cartData.orderPromotion) {
            let totalNum = NumberUtil.toNumber(cartData.totalNum);
            let totalPrice = NumberUtil.toNumber(cartData.totalPrice);
            let promotionIndex = undefined;
            if (cartData.orderPromotion.type_ == 1) {
                //买赠
                if (cartData.orderPromotion.is_stair_) {
                    //启用阶梯
                    for (var i in cartData.orderPromotion.item_list_) {
                        cartData.orderPromotion.item_list_[i].isUse = undefined;
                        if (totalPrice >= cartData.orderPromotion.item_list_[i].target_money_) {
                            promotionIndex = i;
                            if (i > 0) {
                                cartData.orderPromotion.item_list_[i - 1].isUse = false;
                            }
                        }
                    }
                } else {
                    promotionIndex = totalPrice >= NumberUtil.toNumber(cartData.orderPromotion.item_list_[0].target_money_) ? 0 : undefined;
                }
                if (promotionIndex != undefined) {
                    /*
                     // 注:这个算法本来就是有错误的-需要判断是否启用阶梯,再判断是否要按倍数计算
                     let target_money_ = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].target_money_);
                     let multiple = Math.floor(totalPrice / target_money_);   //倍数
                     cartData.presentNumber = MathUtil.mul(multiple, NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].present_number_));
                     cartData.orderPromotion.item_list_[promotionIndex].real_present_number_ = cartData.presentNumber;
                     cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                     cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                     */
                    cartData.presentNumber = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].present_number_);
                    cartData.orderPromotion.item_list_[promotionIndex].real_present_number_ = cartData.presentNumber;
                    cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                    cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[Number(promotionIndex) + 1];
                } else {
                    cartData.useOrderPromotion = undefined;
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[0];
                }
                cartData.promotionTotal = 0;
            } else if (cartData.orderPromotion.type_ == 2) {
                //直降
                if (cartData.orderPromotion.is_stair_) {
                    //启用阶梯
                    for (var i in cartData.orderPromotion.item_list_) {
                        cartData.orderPromotion.item_list_[i].isUse = undefined;
                        if (totalPrice >= cartData.orderPromotion.item_list_[i].target_money_) {
                            promotionIndex = i;
                            if (i > 0) {
                                cartData.orderPromotion.item_list_[i - 1].isUse = false;
                            }
                        }
                    }
                } else {
                    promotionIndex = totalPrice >= NumberUtil.toNumber(cartData.orderPromotion.item_list_[0].target_money_) ? 0 : undefined;
                }
                if (promotionIndex != undefined) {
                    /*
                     cartData.orderPromotion.item_list_[promotionIndex].isUse = isUse;
                     cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                     let targetMoney = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].target_money_);
                     let cutMoney = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].cut_money_);
                     cartData.promotionTotal = Math.floor(MathUtil.div(totalPrice, targetMoney)) * cutMoney;
                     */
                    let cutMoney = NumberUtil.toNumber(cartData.orderPromotion.item_list_[promotionIndex].cut_money_);
                    cartData.promotionTotal = cutMoney;
                    cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                    cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[Number(promotionIndex) + 1];
                } else {
                    cartData.useOrderPromotion = undefined;
                    cartData.promotionTotal = 0;
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[0];
                }
            } else if (cartData.orderPromotion.type_ == 3) {
                //打折
                if (cartData.orderPromotion.is_stair_) {
                    //启用阶梯
                    for (var i in cartData.orderPromotion.item_list_) {
                        cartData.orderPromotion.item_list_[i].isUse = undefined;
                        if (totalPrice >= cartData.orderPromotion.item_list_[i].target_money_) {
                            promotionIndex = i;
                            if (i > 0) {
                                cartData.orderPromotion.item_list_[i - 1].isUse = false;
                            }
                        }
                    }
                } else {
                    promotionIndex = totalPrice >= NumberUtil.toNumber(cartData.orderPromotion.item_list_[0].target_money_) ? 0 : undefined;
                }
                if (promotionIndex != undefined) {
                    cartData.promotionTotal = MathUtil.mul(totalPrice, MathUtil.minus(1, cartData.orderPromotion.item_list_[promotionIndex].cut_percent_ / 100.00));
                    cartData.orderPromotion.item_list_[promotionIndex].isUse = true;
                    cartData.useOrderPromotion = cartData.orderPromotion.item_list_[promotionIndex];
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[Number(promotionIndex) + 1];
                } else {
                    cartData.useOrderPromotion = undefined;
                    cartData.promotionTotal = 0;
                    cartData.nextUseOrderPromotion = cartData.orderPromotion.item_list_[0];
                }
            }
        } else {
            cartData.promotionTotal = 0;
        }
        return cartData;
    },
    checkExperience: companyId => {
        const experienceCompanyIds = [118, 729, 724, 121, 128, 117, 124, 116, 119, 122, 123, 725];
        return experienceCompanyIds.includes(Number(companyId));
    },
    clearAccount: () => {
        //管理端退出
        localStorage.removeItem("ysMgrUser");
        //订货端退出
        localStorage.removeItem("ysUser");
        //删除购物车信息
        delete window.cartNumber;
        delete window.cartCount;
        delete window.cartTotal;
        localStorage.removeItem('cartNumber');
        localStorage.removeItem('cartCount');
        localStorage.removeItem('cartTotal');
        localStorage.removeItem("mgrAccountList");
        localStorage.removeItem("shopAccountList");
    },
    toLogout: (rUrl, save) => {
        const query = BusinessUtil.getSearchFromUrl();

        if (!save) {
            BusinessUtil.clearAccount();
        }

        const hostUrl = BusinessUtil.buildHostUrl();
        // 获取分享人
        const shareUserId = StorageUtil.getItem('_shareClientId_') || StorageUtil.getItem(SystemConst.shareUserId, true);
        const shareClientId = StorageUtil.getItem(SystemConst.shareClientId, true);
        const search = shareUserId ? `&u=${shareUserId}` : shareClientId ? `&c=${shareClientId}` : ``;

        // 清除本地缓存
        // localStorage.clear();
        localStorage.removeItem("ysUser");
        sessionStorage.clear();
        StorageUtil.setItem(SystemConst.companyId, query.companyId);

        let logOutUrl = `${hostUrl}/${rUrl || 'login'}?companyId=${query.companyId}${search}`;
        if (CheckUtil.isSecondUrl) {
            //如果是第二正式url  am.ysdinghuo.com
            logOutUrl = `https://astore${query.companyId}.${UrlUtil.getHost()}.com/${rUrl || 'login'}?companyId=${query.companyId}${search}`;
        } else if (CheckUtil.isThirdUrl) {
            logOutUrl = `https://bstore${query.companyId}.${UrlUtil.getHost()}.com/${rUrl || 'login'}?companyId=${query.companyId}${search}`;
        }
        window.location.href = logOutUrl;

    },
    //企業注冊
    toCompanyRegister() {
        let url = UrlUtil.getAccountUrl() + '/register';
        window.location.href = url;
    },

    //检查是否已登录
    isLogin: () => {
        const companyId = StorageUtil.getItem(SystemConst.platformCompanyId) || StorageUtil.getItem(SystemConst.companyId);
        if (companyId) {
            const ysUser = StorageUtil.getItem(SystemConst.mShop_user);
            //如果已有用户登录信息,判断用户存储的用户信息的企业id是否跟当前访问的企业一致
            if (ysUser) {
                let userCompanyId = ysUser.company_id_;
                if (+companyId !== userCompanyId) {
                    // localStorage.removeItem('ysUser');
                    // localStorage.removeItem("accountData");
                    // localStorage.removeItem("mgrAccountList");
                    // localStorage.removeItem("shopAccountList");
                    // localStorage.removeItem("token");
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }
    },


    //确认是否跳转登录
    toLogin: (path) => {
        if (!BusinessUtil.isLogin()) {
            let companyId = localStorage.getItem("companyId");
            // 统一支持nextPath参数，生产环境也传递
            location.href = BusinessUtil.buildHostUrl() + '/login?companyId=' + companyId + (path ? ('&nextPath=' + encodeURIComponent(path)) : '');
            return;
        } else {
            return
        }
    },

    buildHostUrl: () => {
        const {hostname} = window.location;
        const query = BusinessUtil.getSearchFromUrl();
        if (process.env.API_ENV === 'prod') {
            if (CheckUtil.isSecondUrl) {
                return `https://astore${query.companyId}.${UrlUtil.getHost()}.com`;

            } else if (CheckUtil.isThirdUrl) {
                return `https://bstore${query.companyId}.${UrlUtil.getHost()}.com`;
            }
            return `https://store${query.companyId}.${UrlUtil.getHost()}.com`;
        } else if (process.env.API_ENV === 'test') {
            return `http://store${query.companyId}.yimaideng.cn`;
        } else {
            return `http://${hostname}:8993`;
        }

    },
    // 获取url参数
    getSearchFromUrl(search = window.location.search) {
        let searchObj = {};
        const subIndex = search.indexOf("?");
        if (subIndex > -1) {
            search = search.substr(subIndex + 1);
        }
        search.split('&').map(item => {
            const itemArr = item.split("=");
            if (itemArr[0] && itemArr[1]) {
                searchObj[itemArr[0]] = itemArr[1];
            }
        });
        return searchObj;
    },
    //清除用户账号信息
    cleanAccountData: (newCompanyId) => {
        //有传值
        if (newCompanyId && localStorage.getItem("ysUser")) {
            //如果两次企业不一致
            // if (newCompanyId != JSON.parse(localStorage.getItem("ysUser")).company_id_) {
            //     localStorage.removeItem('ysUser');
            //     localStorage.removeItem("accountData");
            //     localStorage.removeItem("mgrAccountList");
            //     localStorage.removeItem("shopAccountList");
            //     localStorage.removeItem("token");
            // }
        }
    },
    // 小程序处理-- 永远带上分享的业务id
    fixWxMiniProgramShare: (url) => {
        if (!url) {
            url = location.href;
        }
        const shareUserId = StorageUtil.getItem('_shareClientId_') || StorageUtil.getItem(SystemConst.shareUserId, true);
        const shareClientId = StorageUtil.getItem(SystemConst.shareClientId, true);
        const search = shareUserId ? `&u=${shareUserId}` : shareClientId ? `&c=${shareClientId}` : ``;
        return url + search;
    },

    fixShareParams: () => {
        const query = {};
        const shareUserId = StorageUtil.getItem('_shareClientId_') || StorageUtil.getItem(SystemConst.shareUserId, true);
        const shareClientId = StorageUtil.getItem(SystemConst.shareClientId, true);
        if (shareUserId) {
            query.u = shareUserId;
        }
        if (shareClientId) {
            query.c = shareClientId;
        }
        return query;
    },

    // 退货单状态
    refundStatus: {
        '11,21,31': '待审核',
        '41,51': '待退货',
        '61,71': '待退款',
        '100': '已完成',
        '999': '已取消',
    },
};


export {BusinessUtil};




// WEBPACK FOOTER //
// ./src/utils/BusinessUtil.js